import { FeatureDefinitions } from "../../models/FeatureDefinitions"
import { FullFeatureSet } from "../FullFeatureSet"

const YAPLA = "communications.yapla.com"
const CAKEMAIL = "app.cakemail.com"

/**
 * Features Yapla accounts get on every plan, Free included, whatever Yapla's Stripe prices say:
 * Yapla creates its accounts with them on (about 18,300 of 18,440 accounts in November 2026).
 */
const YAPLA_FEATURES_ON_EVERY_PLAN = [
    "use_behavioral_segmentation",
    "use_html_editor",
    "use_contact_export",
    "use_list_redirection",
    "drip_campaigns",
]

const HIDDEN_FEATURES: Record<string, string[]> = {
    [YAPLA]: ["priority_phone_support", "ongoing_email_support"],
}

const LABEL_OVERRIDES: Record<string, Record<string, string>> = {
    [CAKEMAIL]: { priority_phone_support: "video_appointments" },
}

/**
 * Staging brands live at the production address with "staging" after the first label
 * (app.staging.cakemail.com); they follow the production brand's rules.
 */
function productionAddress(partnerUrl: string | undefined) {
    return partnerUrl?.replace(/^([^.]+)\.staging\./, "$1.")
}

/**
 * Adjusts the features a plan card or table shows for the partner brand.
 * Call it after the plan-specific overrides, so the brand has the last word.
 */
export function applyBrandFeatureDisplay(partnerUrl: string | undefined, features: FullFeatureSet, planCategory?: string) {
    if (productionAddress(partnerUrl) === YAPLA) {
        YAPLA_FEATURES_ON_EVERY_PLAN.forEach((feature) => {
            features[feature] = true
        })
        // Yapla offers 2 audiences on Free (its integration's limit; Cakemail does not cap Yapla accounts)
        if (planCategory === "free") {
            features.lists = 2
        }
    }
    return features
}

/**
 * True when the brand does not list this feature on its pricing page at all.
 */
export function isFeatureHiddenForBrand(partnerUrl: string | undefined, feature: string) {
    const address = productionAddress(partnerUrl)
    return (address && HIDDEN_FEATURES[address]?.includes(feature)) || false
}

/**
 * The translation label of a feature for the brand ("feature-<label>" and "feature-<label>-description").
 */
export function featureLabelForBrand(partnerUrl: string | undefined, feature: string) {
    const address = productionAddress(partnerUrl)
    return (address && LABEL_OVERRIDES[address]?.[feature]) || FeatureDefinitions[feature]?.label
}
